import { PageSeo } from "./PageSeo.js";

/** One entry per public route. Titles under 60 chars, descriptions under 160. */
export const PAGE_SEO: PageSeo[] = [
  new PageSeo({
    route: "/",
    title: "Turnstill | 3D product renders and spins for sellers",
    description: "3D product spins, hero renders and ad creatives for Amazon, TikTok Shop and Etsy sellers and small brands. Fixed prices, free sample available.",
  }),
  new PageSeo({
    route: "/packages",
    title: "Packages and prices | Turnstill",
    description: "Fixed launch prices for 3D product spins, hero renders, campaign sets and 10-product bundles. See what is included and how long it takes.",
  }),
  new PageSeo({
    route: "/quote",
    title: "Get a quote or a free sample render | Turnstill",
    description: "Request a fixed quote for 3D product renders, or ask for a free watermarked sample using a product link and two photo links. No payment on the form.",
  }),
  new PageSeo({
    route: "/about",
    title: "About Turnstill | 3D product render studio",
    description: "Turnstill is a small 3D studio making product spins, hero stills and ad creatives in Blender for online sellers, without a photo shoot.",
  }),
  new PageSeo({
    route: "/contact",
    title: "Contact | Turnstill",
    description: "Send Turnstill a message about a 3D product render, spin or ad creative project.",
  }),
  new PageSeo({
    route: "/terms",
    title: "Terms of service | Turnstill",
    description: "Plain-English service terms for Turnstill 3D render projects: scope, revisions, delivery, licence, refunds and liability. Draft.",
  }),
  new PageSeo({
    route: "/privacy",
    title: "Privacy policy | Turnstill",
    description: "What the Turnstill website collects (contact form fields only), who processes it and how to ask for deletion. Draft.",
  }),
];

export const NOT_FOUND_SEO = new PageSeo({
  route: "/",
  title: "Turnstill | 3D product renders and spins for sellers",
  description: PAGE_SEO[0]!.description,
});

/** Look up a hash route; unknown routes fall back to home (App redirects them). */
export function seoFor(route: string): PageSeo {
  const clean = route.split("?")[0] || "/";
  return PAGE_SEO.find((p) => p.route === clean) ?? NOT_FOUND_SEO;
}
